import React, { useEffect, useState } from "react";
import MarketingHeader from "@/components/marketing/Header";
import MarketingFooter from "@/components/marketing/Footer";
import QuoteForm from "@/components/marketing/QuoteForm";
import api from "@/lib/api";
import { Mail, Phone, MapPin, Clock3 } from "lucide-react";

export default function Contact() {
  const [content, setContent] = useState(null);
  useEffect(() => {
    api.get("/content").then((r) => setContent(r.data)).catch(() => {});
    if (window.location.hash === "#quote") {
      setTimeout(() => document.getElementById("quote")?.scrollIntoView({ behavior: "smooth" }), 300);
    }
  }, []);
  const c = content?.contact || {};

  return (
    <div className="min-h-screen bg-white">
      <MarketingHeader />

      <section className="bg-[#0a2540] text-white">
        <div className="max-w-7xl mx-auto px-6 py-24">
          <h1 className="font-display text-4xl sm:text-5xl font-light">Contact Us</h1>
          <p className="mt-4 text-white/70 max-w-2xl leading-relaxed">{c.intro}</p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 py-20 grid lg:grid-cols-2 gap-12">
        <div>
          <h2 className="font-display text-2xl font-medium text-[#0a2540] mb-8">Reach the team</h2>
          <div className="space-y-5">
            <InfoRow icon={<Mail className="h-5 w-5" />} label="Email" value={c.email} testid="contact-email" />
            <InfoRow icon={<Phone className="h-5 w-5" />} label="Phone" value={c.phone} testid="contact-phone" />
            <InfoRow icon={<MapPin className="h-5 w-5" />} label="Address" value={c.address} testid="contact-address" />
            <InfoRow icon={<Clock3 className="h-5 w-5" />} label="Hours" value={c.hours} testid="contact-hours" />
          </div>
        </div>
        <div id="quote" className="bg-white border border-slate-200 rounded-2xl p-8 shadow-sm scroll-mt-24">
          <h2 className="font-display text-2xl font-medium text-[#0a2540] mb-2">Get a quote</h2>
          <p className="text-sm text-slate-500 mb-6">Tell us about your organization and we'll get back to you shortly.</p>
          <QuoteForm />
        </div>
      </section>

      <MarketingFooter />
    </div>
  );
}

function InfoRow({ icon, label, value, testid }) {
  return (
    <div className="flex items-start gap-4 border border-slate-200 rounded-xl p-5 bg-white">
      <div className="h-10 w-10 rounded-lg bg-teal-50 text-teal-600 flex items-center justify-center shrink-0">{icon}</div>
      <div>
        <div className="text-xs uppercase tracking-widest text-slate-400">{label}</div>
        <div className="text-[#0a2540] font-medium mt-1" data-testid={testid}>{value || "—"}</div>
      </div>
    </div>
  );
}
